var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #WS .cls-1 {\n        fill: #006cff;\n      }\n\n      #WS .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_385",
    "data-name": "Pfad 385",
    className: "cls-1",
    d: "M18,0A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1005",
    "data-name": "Gruppe 1005",
    transform: "translate(7.35 4.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_386",
    "data-name": "Pfad 386",
    className: "cls-2",
    d: "M21.25,7.7H13.6V9.8h-.3A8.48,8.48,0,0,0,8.8,11C7,12.2,5.05,14,4.9,19.1H10c0-4.5,2.7-4.35,3.45-4.35h0V15.8H21.1V14.75h2.25V9.8H21.1V7.7Zm1.35,3v3H20.2v1.05H14.65V13.7H13.3c-2.55,0-3.9,1.5-4.2,4.35h-3c.3-3.75,1.8-5.25,3.3-6.3a6.818,6.818,0,0,1,3.9-1.05h1.35V8.6H20.2v2.1h2.4Z",
    transform: "translate(-4.9 -0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1583",
    "data-name": "Rechteck 1583",
    className: "cls-2",
    width: 2.85,
    height: 10.2,
    transform: "translate(19.5 6.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_387",
    "data-name": "Pfad 387",
    className: "cls-2",
    d: "M11.05,6.05h2.7V8.9h1.8V6.05h2.7A.709.709,0,0,0,19,5.3V4.85a.709.709,0,0,0-.75-.75h-2.7V3.8a.9.9,0,0,0-1.8,0v.45h-2.7A.709.709,0,0,0,10.3,5v.3A.8.8,0,0,0,11.05,6.05Z",
    transform: "translate(-2.2 -2.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_388",
    "data-name": "Pfad 388",
    className: "cls-2",
    d: "M5.3,19.85A1.986,1.986,0,0,0,7.25,21.8a2.123,2.123,0,0,0,2.1-1.95c0-1.05-1.95-4.05-1.95-4.05S5.3,18.8,5.3,19.85Z",
    transform: "translate(-4.7 3.55)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupply);
export default __webpack_public_path__ + "static/media/water-supply.e9778da2cdba36d9217eed7827f753f9.svg";
export { ForwardRef as ReactComponent };